// src/components/data-display/DataTable.jsx
import React from 'react';
import { DataTableHeader } from './DataTableHeader';
import { DataTableRows } from './DataTableRows';
import { DataTableFooter } from './DataTableFooter';
import { ThemedFlex } from '../../theme/ThemedFlex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { HighlightedDataPoint } from './HighlightedDataPoint';
import { usePagination } from '../../utils/usePagination';

export const DataTable = ({
  title,
  subtitle,
  icon,
  rows,
  link,
  linkLabel = 'Learn More',
  animateLastBlock,
  animate,
  showIcon = false,
  highlightedData,
  rowsPerPage = 15,
  specificTerm,
  onOpenLexicon,
}) => {
  const { currentPage, setCurrentPage, pageCount } = usePagination(rows, rowsPerPage);

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      minWidth={{ base: '100%', md: '400px' }}
      className={animate ? 'gray-border-custom gray-border' : ''}
      justifyContent="flex-start"
    >
      <DataTableHeader
        title={title}
        subtitle={subtitle}
        icon={icon}
        animateLastBlock={animateLastBlock}
        onOpenLexicon={onOpenLexicon}
        specificTerm={specificTerm}
      />
      {highlightedData && (
        <HighlightedDataPoint
          label={highlightedData.label}
          value={highlightedData.value}
        />
      )}

      <DataTableRows 
        rows={rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)} 
        onOpenLexicon={onOpenLexicon}
      />

      <DataTableFooter
        link={link}
        linkLabel={linkLabel}
        footerIcon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
        showIcon={showIcon}
        pagination={{ currentPage, setCurrentPage, pageCount }}
        specificTerm={specificTerm}
        onOpenLexicon={onOpenLexicon}
      />
    </ThemedFlex>
  );
};